<template>
  <template v-if="showLogin">
    <div class="login-header">
        <h3 class="text-uppercase title">{{ this.$translations.login.title }}</h3>
        <button type="button" class="login-close" @click="closeLogin()">
          <i class="mm-icon close">
            <svg role="presentation"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="icon"
              aria-hidden="true">
              <use href="#close" />
            </svg>
          </i>
        </button>
    </div>
    <div class="login-header-subtitle">{{ this.$translations.login.description }}</div>
    <form
      class="mm-form--needs-validation login"
      name="login-form"
      novalidate="novalidate"
      id="login-form-chatbot">

      <fieldset class="mm-form-fieldset">
        <div class="mm-form-input -floating-label">
          <input type="email" id="login-form-email" v-model="loginFormEmail" required="required" :placeholder="this.$translations.placeholder.password" name="loginEmail" />
          <label for="login-form-email">
            {{ this.$translations.placeholder.email }}
          </label>
        </div>

        <div class="mm-form-input  -floating-label" data-component="MMTogglePasswordComponent">
          <input type="password" autocomplete="off" id="login-form-password" v-model="loginFormPassword" required="required" :placeholder="this.$translations.placeholder.password" name="loginPassword" />
          <button type="button" class="mm-button -icon -ghost toggle-password js-toggle-password custom-bg-btn -xl" :aria-label="this.$translations.buttons.togglepassword">
            <i class="mm-icon visible-password">
              <svg role="presentation"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="icon"
                aria-hidden="true">
                <use href="#eye" />
              </svg>
            </i>
            <i class="mm-icon hidden-password">
              <svg role="presentation"
                xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink"
                class="icon"
                aria-hidden="true">
                <use href="#eye-closed" />
              </svg>
            </i>
          </button>
          <label for="login-form-password">{{ this.$translations.placeholder.password }}</label>
        </div>

        <button type="button" @click="this.showLogin = false" class="text-uppercase forgot-password">
          {{ this.$translations.login.account.forgot}}
        </button>

        <input type="hidden" name="csrf_token" v-model="this.token" />

        <button type="button" @click="sendLogin()"
          class="login-submit mm-button -solid"
          :aria-label="this.$translations.login.account.submit">
          {{ this.$translations.login.account.submit }}</button>
      </fieldset>
    </form>
    <a :href="this.$urls.registrationUrl" target="_blank" class="mm-button mt-1 -block">
        {{ this.$translations.login.account.create }}
    </a>
  </template>
  <template v-else>

    <div class="login-header">
        <button type="button" class="login-back" @click="this.showLogin = true">
          <i class="mm-icon arrow-left">
            <svg role="presentation"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              class="icon"
              aria-hidden="true">
              <use href="#arrow-left" />
            </svg>
          </i>
          <h3 class="text-uppercase title">{{ this.$translations.forgot.password.backtologin }}</h3>
        </button>
    </div>
    <div class="login-header-subtitle">{{ this.$translations.forgot.password.description }}</div>
    <form
      id="forgot-password-form"
      class="reset-password-form form-login-forgot-password mm-form--needs-validation"
      name="forgot-password-form">

      <div class="mm-form-input -floating-label my-2">
        <input type="email"
          id="forgot-password-form-email"
          required="required"
          :placeholder="this.$translations.placeholder.email"
          name="email"
          autocomplete="username"
          novalidate
          v-model="this.loginFormEmail" />

        <label for="forgot-password-form-email">
          {{this.$translations.placeholder.email}}
        </label>
      </div>

      <button type="button" @click="sendForgotPassword()" class="mm-button -solid -xl -block">
        {{this.$translations.forgot.password.submit}}
      </button>

      <p class="recaptcha-subtext" v-html="this.$translations.label.recaptcha.subtext"></p>
    </form>
  </template>
</template>

<script>

export default {
    data() {
      return {
        showLogin: true,
        loginFormEmail: '',
        loginFormPassword: '',
        resetPasswordDone: false,
        resetPasswordError: false,
        token: ''
      }
    },
    emits: ['closeLogin', 'loginDone', 'loginError'],
    methods: {
      sendLogin() {
        const loginUrl = this.$urls.loginUrl;
        const refreshHeaderUrl = this.$urls.refreshHeaderUrl;
        if (this.loginFormEmail !== '' && this.loginFormPassword !== '') {
          const formData = new FormData(document.getElementById('login-form-chatbot'));
          this.$http
            .post(loginUrl, formData)
            .then(response => {
              const data = response.data;
              if (data.success) {
                this.$emit('loginDone', data.authCustomerObj);
                // TODO: nice to have --> refresh page header
                // this.$http
                //   .get(refreshHeaderUrl)
                //   .then(res => {
                //     console.log(res.data);
                //     let headerLoginBtnParent = document.querySelector('.mm-button[data-option-mobileopenid="login-modal"]').parentElement;
                //     headerLoginBtnParent.innerHTML = res.data;
                //   })
              } else {
                this.$emit('loginError', data.error[0]);
              }
            });
        }
      },
      sendForgotPassword() {
        const forgotPasswordUrl = this.$urls.forgotPasswordUrl;
        const recaptchaElement = document.getElementById('gReCaptchaResetPassword');

        if (this.loginFormEmail !== '') {
          const formData = new FormData(document.getElementById('forgot-password-form'));
          if (recaptchaElement) {
            formData.append('g-recaptcha-response', recaptchaElement.value);
          }
          this.$http
            .post(forgotPasswordUrl, formData)
            .then((response) => {
              if (response.status === 200 && response.data.success) {
                this.resetPasswordDone = true;
              } else {
                this.resetPasswordDone = false;
                this.resetPasswordError = true;
              }
            });
        }
      },
      closeLogin() {
        this.$emit('closeLogin');
      }
    },
    created() {
      this.token = this.$csrf.token;
    }
}
</script>
